import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Search from "./Search.jsx";
import { DealerContextProvider } from "../../contexts/DealerContext.jsx";
import ResultsContainer from "./ResultsContainer.jsx";
import { GrowthBookProvider } from "@growthbook/growthbook-react";

const DealerLocator = ({basePath, apiKey}) => {

  return (
    <div className="ft_dealer-locator">
      <Router basename={basePath}>
        <GrowthBookProvider growthbook={window.growth_book}>
          <DealerContextProvider apiKey={apiKey}>
            <Switch>
              <Route path='/search' component={ResultsContainer} />
              <Route index component={Search} />
            </Switch>
          </DealerContextProvider>
        </GrowthBookProvider>
      </Router>
    </div>
  );

}

export default DealerLocator;
